/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */

import { Reducer } from "redux";
import *as actionsTypesFromStore from '@apps-store/@types';
import { ReducersInterface } from '@apps-store/models';
import * as actions from '@apps-store/enums';

/**
 * @function RealTimesReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeRealTimesAction } action: action de l'application
 * @return { Reducer }
 */
export const RealTimesReducer: Reducer< ReducersInterface<any>> = ( state: any = {
   
} , action: actionsTypesFromStore.TypeRealTimesAction) => {
    
    switch (action.type) {

        case actions.RealTimesTypes.REALTIMES_INPROGRESS:

            return {

                loading: true,
                ...state

            }
            
            break;
        case actions.RealTimesTypes.REALTIMES_FAIL:

            return {

                error: action.payload.error ,
                loading: false,
                
            }
            
            break;
        
        case actions.RealTimesTypes.REALTIMES_SUCCESS:

            return {

                data: action.payload.data ,
                loading: false,
                
            }
            
            break;
    
        default:
            return state
            break;
    }
    
}


// WEBPACK FOOTER //
// ./src/apps/store/reducers/realtimes/index.ts